import * as React from 'react';
import { Box, Button, Drawer, Theme, Typography, createStyles, makeStyles } from '@material-ui/core';
import CheckCircleOutlineOutlinedIcon from '@material-ui/icons/CheckCircleOutlineOutlined';
import { useAppDispatch, useTypedSelector } from 'combineReducers';
import { drawerAction } from 'slices/drawer';
import { useTranslation } from 'react-i18next';

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    drawer: {
      minWidth: 380
    },
    drawerTitle: {
      marginBottom: theme.spacing(2),
      fontWeight: theme.typography.fontWeightMedium
    },
    productIcon: {
      fontSize: 20,
      marginRight: theme.spacing(1)
    }
  })
);

export const OnlineTrainingDrawer: React.FC = () => {
  const classes = useStyles();
  const dispatch = useAppDispatch();
  const { t } = useTranslation('subscriber');
  const { credits } = useTypedSelector(state => state.onlineTrainingCredits);
  const { isOpen } = useTypedSelector(state => state.drawer);

  return (
    credits && (
      <Drawer anchor="right" open={isOpen} onClose={() => dispatch(drawerAction.closeDrawer())}>
        <Box mt={2} pl={2} pr={2} className={classes.drawer} display="flex" flexDirection="column">
          <Typography classes={{ root: classes.drawerTitle }} variant="subtitle1">
            {t('onlineTraining.subtitle', 'Purchased courses')}
          </Typography>
          {credits?.Breakdown &&
            Object.entries(credits.Breakdown).map(([product, workers]) => (
              <Box display="flex" alignItems="center" marginBottom={2} key={product}>
                <CheckCircleOutlineOutlinedIcon classes={{ root: classes.productIcon }} color="primary" />
                <Box display="flex" flexDirection="column">
                  <span>{product}</span>
                  <span>{`${workers} worker${workers <= 1 ? '' : 's'}`}</span>
                </Box>
              </Box>
            ))}
        </Box>
        <Box paddingTop={3} paddingLeft={1}>
          <Button color="primary" onClick={() => dispatch(drawerAction.closeDrawer())}>
            {t('onlineTraining.btnClose', 'CLOSE')}
          </Button>
        </Box>
      </Drawer>
    )
  );
};
